/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Viacheslav Smalenski
 * @version 1.28.0
 * @since 1.28.0
 */

import { ICorporateFormTranslation } from '@modules/internationalization/types/corporate';
import { stringFormatParams } from '@utils/stringFormat';

export const getGlobalInputErrorModalTitle = (
    tForm: ICorporateFormTranslation,
    filesLength: number,
    maxFilesLength: number,
) => {
    if (filesLength % 10 === 1 && filesLength % 100 !== 11) {
        return stringFormatParams(tForm.maxLengthFilesErrorModal.title_one, {
            maxCount: maxFilesLength,
            filesCount: filesLength,
        });
    }

    if (filesLength % 10 >= 2 && filesLength % 10 <= 4 && (filesLength % 100 < 10 || filesLength % 100 >= 20)) {
        return stringFormatParams(tForm.maxLengthFilesErrorModal.title_few, {
            maxCount: maxFilesLength,
            filesCount: filesLength,
        });
    }

    return stringFormatParams(tForm.maxLengthFilesErrorModal.title, {
        maxCount: maxFilesLength,
        filesCount: filesLength,
    });
};
